export default "__VITE_ASSET__B9rSPKT5__"